import { Box } from '@origin-digital/layout';
import { Button, Colors, LinkText } from '@origin-digital/style-guide';
import * as React from 'react';
import { AuthCard } from '../../../../components/Card';
import { Heading } from '../../../../components/Heading';
import { InfoText } from '../../../../components/InfoText';
import { Separator } from '../../../../components/Separator';
import { FeatureSwitch, FeatureSwitchOff } from '@origin-digital/features';
import { Page } from '../../../../components/Page';

interface AccountFoundViewProps {
  email: string;
  forgotPasswordHref: string;
  onLoginClick: () => void;
  children?: React.ReactNode;
}

const AccountFoundView: React.FC<AccountFoundViewProps> = ({
  email,
  forgotPasswordHref,
  children,
  onLoginClick,
}) => {
  return (
    <Page>
      <AuthCard>
        <div>
          <Heading text="Hooray we found your account" />
          <FeatureSwitch name="sales-r2d2-account-found-login">
            <InfoText
              text={`Your email is **${email}**. Enter your password and click log in to continue.`}
            />
          </FeatureSwitch>
          <FeatureSwitchOff name="sales-r2d2-account-found-login">
            <InfoText
              text={`Your email is **${email}**. Click log in to continue and enter your password.`}
            />
            <Button
              data-id="login"
              text="Log in"
              name="login"
              block={true}
              onClick={onLoginClick}
            />
          </FeatureSwitchOff>
          {children}
          <Box marginTop={8} marginBottom={8}>
            <LinkText
              componentType="link"
              label="forgot-my-password"
              data-id="forgot-email"
              color="dark"
              text="Forgot my password"
              href={forgotPasswordHref}
            />
          </Box>
          <Separator color={Colors.GREY8} />
          <Box display="flex" justifyContent="center" marginTop={8}>
            <LinkText
              componentType="link"
              label="change-email-link"
              color="red"
              data-id="change-email-link"
              href={'mailto:support@originenergy.com.au'}
              text="Need to change your email? Contact us"
            />
          </Box>
        </div>
      </AuthCard>
    </Page>
  );
};

export { AccountFoundView };
